import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=f703aad6&lang=pug"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=f703aad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports